import request from "../utils/request";

/**
 * 注册
 * account, password, fcode 必填
 * @export
 * @param {*} [param={}]
 * @returns
 */
//获取用户信息
export function userInfo(param = {}, resParams) {
    return request.post("/user/info", param, resParams);
}
//获取配置信息
export function getConfig(param = {}, resParams) {
    return request.post("/configure/getV2", param, resParams);
}
// 获取默认配置
export function getFeatureList(param = {}, resParams) {
    return request.post("/feature/list", param, resParams);
}
// 获取机器人列表
export function getUserRobots(resParams) {
    return request.post("/user/robots", null, resParams);
}
// 获取机器人列表
export function getUserRobotsInfo(resParams) {
    return request.post("/user/robotsInfo", null, resParams);
}
// 获取房间大哥列表
// export function getKeypersonList(param = {}, resParams) {
//     return request.post('/configure/room_top', param, resParams)
// }
// 获取微信配置
export function getWechatSdk(param = {}, resParams) {
    return request.post("/wechat/jssdk_config", param, resParams);
}
// 创建微信公众号订单
export function createWechatPayOrder(param = {}, resParams) {
    return request.post("/fcode/createorder", param, resParams);
}
// 创建微信公众号订单支付
export function createWechatPay(param = {}, resParams) {
    return request.post("/fcode/h5pay", param, resParams);
}
// 创建微信H5订单
export function createMobileWxPay(param = {}, resParams) {
    return request.post("/fcode/mobileWXPay", param, resParams);
}
// 创建支付宝H5订单
export function createMobileAliPay(param = {}, resParams) {
    return request.post("/fcode/mobileAlipay", param, resParams);
}
// 创建订单
export function createFcodeOrder(param = {}, resParams) {
    return request.post("/fcode/newpay", param, resParams);
}
// 查询订单
export function checkFcodeOrder(param = {}, resParams) {
    return request.post("/fcode/order_query", param, resParams);
}
// 获取功能信息 购买用
export function getFeatureProducts(param = {}, resParams) {
    return request.get("/feature/products", param, resParams);
}
// 获取AITOKEN
export function getAIToken(param = {}, resParams) {
    return request.get("/plugin/ai_token", param, resParams);
}
// 更新配置
export function updateConfig(param = {}, resParams) {
    return request.post("/configure/update", param, resParams);
}
// 更新场控数据
export function updateAccount(param = {}, resParams) {
    return request.post("/configure/updateCookie", param, resParams);
}
// 删除场控数据
export function deleteAccount(param = {}, resParams) {
    return request.post("/configure/deleteCookie", param, resParams);
}
// 获取套餐信息 购买用
export function getOrderPags(param = {}, resParams) {
    return request.post("/order/pags", param, resParams);
}
// 获取登录二维码
export function getSignInQrcode(param = {}, resParams) {
    return request.get("/sign/loginqrcode", param, resParams);
}
// 获取扫码信息
export function getSignInStatus(param = {}, resParams) {
    return request.get("/sign/attemptlogin", param, resParams);
}
// 使用F码
export function consumeFCode(Params, resParams) {
    return request.post("/fcode/consume", Params, resParams);
}
// 获取F码信息
export function getFCode(Params = {}, resParams) {
    return request.post("/fcode/get", Params, resParams);
}
// 获取虎牙登录二维码
export function getCloudQrCode(Params = {}, resParams) {
    return request.post("/cloud/qrcode", Params, resParams);
}
// 获取云端状态
export function getCloudStatus(params, resParams) {
    return request.post("/cloud/status", params, resParams);
}
// 查询虎牙登录扫码信息
export function checkCloudLogin(params, resParams) {
    return request.post("/cloud/check", params, resParams);
}
// 启动机器人
export function cloudStart(params) {
    return request.post("/cloud/start", params);
}
// 暂停机器人
export function cloudStop(params) {
    return request.post("/cloud/stop", params);
}
// 退出场控
export function cloudLogout(params) {
    return request.post("/cloud/logout", params);
}
// 场控登录
export function cloudLogin(params) {
    return request.post("/cloud/login", params);
}
// 场控类型查询
export function checkAccountType(params) {
    return request.post("/cloud/isManage", params);
}
// 短信登录的 图片获取接口
export function smsImgInfo(params) {
    return request.post("/cloud/authImgInfo", params);
}

//短信登录的 图片校验接口
export function smsImgVerify(params) {
    return request.post("/cloud/authImgVerify", params);
}
// 账密登录
export function passwordLogin(Params = {}, resParams) {
    return request.post(`/cloud/pslogin`, Params, resParams);
}
// 获取词库信息
export function getFeatureWords(resParams) {
    return request.post("/feature/words", null, resParams);
}
// 获取房间名
export function getRoomName(Params = {}, resParams) {
    return request.post("/cloud/getRoomName", Params, resParams);
}
//推广返现
export function applyDraw(Params = {}, resParams) {
    return request.post("/configure/applydraw", Params, resParams);
}
//首页信息
export function getAgentdata(Params = {}, resParams) {
    return request.post("/configure/agentdata", Params, resParams);
}
//佣金详情
export function getAgentdetail(Params = {}, resParams) {
    return request.post("/configure/agentdetail", Params, resParams);
}
//用户协议阅读更新
export function agreeAgent(Params = {}, resParams) {
    return request.post("/configure/agreeAgent", Params, resParams);
}
//获取礼物信息
export function getGiftinfo(Params = {}, resParams) {
    return request.post("/cloud/getGiftinfo", Params, resParams);
}
//获取推广员列表
export function getAgentUserList(Params = {}, resParams) {
    return request.post("/configure/agentUserList", Params, resParams);
}
// 获取验证码
export function psSmsSend(Params = {}, resParams) {
    return request.post("/cloud/psSmsSend", Params, resParams);
}
// 验证验证码
export function psSmsVerify(Params = {}, resParams) {
    return request.post("/cloud/psSmsVerify", Params, resParams);
}
// 检查免费版机器人时间
export function checkFreeTime(Params = {}, resParams) {
    return request.post("/user/checkFreeTime", Params, resParams);
}
// 删除机器人接口
export function delRobot(Params = {}, resParams) {
    return request.post(`/user/delRobot`, Params, resParams);
}
// 季卡年卡购买判断
export function bigAmount(Params = {}, resParams) {
    return request.post(`/order/bigAmount`, Params, resParams);
}
// 上报引导步骤
export function setGuide(Params = {}, resParams) {
    return request.post(`/user/setGuide`, Params, resParams);
}
// 增加大哥
export function addKeyPerson(Params = {}, resParams) {
    return request.post(`/key_person/add`, Params, resParams);
}
// 删除大哥
export function delKeyPerson(Params = {}, resParams) {
    return request.post(`/key_person/del`, Params, resParams);
}
// 获取大哥列表
export function getKeypersonList(Params = {}, resParams) {
    return request.post(`/key_person/list`, Params, resParams);
}
// 根据昵称查询大哥
export function searchKeyPerson(Params = {}, resParams) {
    return request.post(`/cloud/searchhuyauser`, Params, resParams);
}
// 获取最近5条直播间
export function getLiveHistoryList(Params = {}, resParams) {
    return request.post(`/live_history/list`, Params, resParams);
}
// 获取弹幕列表
export function getLiveHistoryChatList(Params = {}, resParams) {
    return request.post(`/live_history/chatList`, Params, resParams);
}
// 获取送礼列表
export function getLiveHistoryGiftList(Params = {}, resParams) {
    return request.post(`/live_history/giftList`, Params, resParams);
}
// 获取私信条数
export function getPrivateCount(Params = {}, resParams) {
    return request.post(`/private_chat/count`, Params, resParams);
}
// 统计目前使用的客户端版本
export function cv(Params = {}, resParams) {
    return request.get(`/cv`, Params, resParams);
}

// 绝版礼物送礼
export function sendGift(Params = {}, resParams) {
    return request.post("/cloud/sendGift", Params, resParams);
}
// 绝版礼物陪玩送礼
export function sendGift2(Params = {}, resParams) {
    return request.post("/cloud/sendGift2", Params, resParams);
    // return request.post('http://test-io.meipingya.com/api/meipingya:danmu/sendGift2', Params, resParams)
}
// 绝版礼物获取陪玩信息
export function getPWlist(Params = {}, resParams) {
    return request.post("/cloud/getPWlist", Params, resParams);
    // return request.post('http://test-io.meipingya.com/api/meipingya:danmu/getPeiWanList', Params, resParams)
}
// 获取用户的虎牙账户信息
export function getOverage(Params = {}, resParams) {
    return request.post('/cloud/getHuyaInfo', Params, resParams)
}

// 获取打卡用户列表接口
export function getSignUserList(Params = {}, resParams) {
    return request.get('/configure/signUserList', Params, resParams)
}

// 删除打卡用户接口
export function signUserBan(Params = {}, resParams) {
    return request.post('/configure/signUserBan', Params, resParams)
}

//获取免费状态
export function checkFreeState(){
    return request.get('/fcode/checkFree')
}

//获取三天vip
export function getThreeDayVip(){
    return request.get('/fcode/fcodeFree')
}